module.exports = __webpack_public_path__ + "img/support_a3.25a4871e.png";